<div class="image-container" #container>
  <img #image [src]="url" (mousedown)="onMouseDown($event)" (wheel)="onWheel($event)"
    [style.transform]="'translate(' + position.x + 'px, ' + position.y + 'px) scale(' + scale + ')'" />
</div>